import { UserModel } from './../../../store/storeModels/user.model';
import { TicketSettingsService } from './../../../services/settings-services/ticket-settings.service';
import { GeneralService } from './../../../services/general.service';
import { TicketChatService } from 'src/app/services/ticket/ticket-chat.service';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.state';

export interface CallI {
  callerID: any;
  id: number;
  firstName: string;
  surName: string;
  profileImage?: string;
  gender?: string;
  email?: string;
  name?: string;
  postalAddress?: string;
  clientId?: number
}

@Component({
  selector: 'app-ticket-call',
  templateUrl: './ticket-call.component.html',
  styleUrls: ['./ticket-call.component.css']
})
export class TicketCallComponent implements OnInit {
  defaultPix = 'http://ssl.gstatic.com/accounts/ui/avatar_2x.png';
  details: CallI = {
    clientId: 0,
    callerID: 906155137,
    id: 2,
    firstName: 'Sodiq',
    surName: 'Alabi',
    gender: 'Male',
    email: 'adisco4420@gmail.com',
    postalAddress: '14 Tokosi Street, Orile Iganmu Lagos, Niger'
  }
  private pageUrl = window.location.href;
  private toastrConfig = {
    enableHtml: true,
    tapToDismiss: true,
    closeButton: true,
    disableTimeOut: true,
  };
  private webUrl = environment.baseUrl;
  agentList: any[];
  user: UserModel

  constructor(
    private ticketChatSrv: TicketChatService,
    public gs: GeneralService,
    private ticketSetSrv: TicketSettingsService,
    private toastr: ToastrService,
    store: Store<AppState>
  ) {
    store.select('userInfo').subscribe(info => {
      this.user = info.user;
    })
  }

  ngOnInit() {
    this.getAgentToCall();
    this.joinAndnewMsg();
  }
  getAgentToCall() {
    this.ticketSetSrv.fetchAgentsOnCall().subscribe((res: any) => {
      this.agentList = res;
    })
  }
  joinAndnewMsg() {
    this.ticketChatSrv.joinChat();
    this.ticketChatSrv.newMsg().subscribe((data: any) => {
      const code = data.ticketCode;
      if (!code) { return; }
      if (!(window.location.pathname.includes('/ticket-view'))) {
        const msg = `<p><a href="${this.webUrl}/ticket/ticket-view/${code}" target="_blank">view ticket #${code}</a></p>`;
        this.toastr.success(msg, "New Message", this.toastrConfig);
      }
    });
  }
  checkIfUserIsAgent() { }
  
  openModal(res) {
    const modalEl = document.querySelector('#ticketCall');
    if (!modalEl.classList.contains('show')) {
      this.details = res;
      document.getElementById('openTicketCall').click();
      this.playSound()
    }
  }
  playSound() {
    (document.getElementById('callSound') as any).play()
  }
  stopSound() {
    const sound = (document.getElementById('callSound') as any);
    sound.pause();
    sound.currentTime = 0
  }
  viewContact() {
    document.getElementById('closeTicketCall').click();
    // this.gs.displaySpinner('clients')
  }
  get query() {
    const { firstName, name, surName, email, clientId, callerID } = this.details;
    const clientName = name ? name : `${firstName} ${surName}`
    return {
      action: 'create-ticket',
      clientId: clientId ? clientId : 0,
      clientName: clientId ? clientName : callerID,
      clientEmail: clientId ? email : '',
    }
  }

}
